import "@babel/polyfill";
import initFaqAccordion from "@/modules/_old-modules/containers/accordion/faq-accordion";

$(document).ready(function() {
  initFaqAccordion();

  $(".js-faq-accordion-item")
    .on("focus", function() {
      $(this)
        .parents(".faq-accordion__item")
        .addClass("is-focused");
    })
    .on("blur", function() {
      $(this)
        .parents(".faq-accordion__item")
        .removeClass("is-focused");
    });
});
